import type { JSX } from 'react';
import { DateTime } from '@ksyos/date-time';
import { Box, Text } from '@ksyos/design-system';
import { concatOrNull, localeNlString } from '@common/utils/textUtils';

interface ITotalWeightLossChartTooltipProps {
    date: string;
    totalWeightLoss: number;
    weight: number;
}

export function TotalWeightLossChartTooltip(props: ITotalWeightLossChartTooltipProps): JSX.Element {
    return (
        <>
            <Box
                display="flex"
                gap={2}
            >
                <Text>{localeNlString(props.totalWeightLoss)}% TWL,</Text>
                <Text>{concatOrNull(props.weight, 'kg')}</Text>
            </Box>
            <Text>{DateTime.from(props.date).format('LL')}</Text>
        </>
    );
}
